import { render } from "./HdCard.vue?vue&type=template&id=3712ad7a"
import script from "./HdCard.vue?vue&type=script&lang=js"
export * from "./HdCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__